import Vue from 'vue';
import {serviceInjection} from "./service";

Vue.use(serviceInjection)
